import { render } from "./CustomTemplateEditor.vue?vue&type=template&id=27964126&scoped=true"
import script from "./CustomTemplateEditor.vue?vue&type=script&lang=js"
export * from "./CustomTemplateEditor.vue?vue&type=script&lang=js"

import "./CustomTemplateEditor.vue?vue&type=style&index=0&id=27964126&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27964126"]])

export default __exports__